<div class="coned-container">
    <div class="coned-header">
        <span class="coned-title">{{ 'Home.cphalearning' | translate }}</span>
    </div>

    <div class="coned-body">
      <div class="coned-subtitle">{{ 'Home.featuredcourses' | translate }}</div>
      <div *ngIf="continuingEducationList">
            <div class="coned-card" *ngFor="let item of continuingEducationList">
              <h2 class="coned-title-card">{{ item.title }}</h2>
              <p class="coned-description">
                {{ item.description }}
              </p>        
              <div class="coned-footer">                
                <div class="coned-ceu" *ngIf="item.tags">
                  {{ item.tags }}
                </div>        
                <a class="coned-more"
                    href="javascript:void(0)"
                    (click)="onLearnMoreClick(item)">
                    {{ item.link.text }}
                  </a>       
              </div>
            </div>
      </div>      
      <div class="coned-link">
        <a href="" target="_blank" (click)="onViewAllCoursesClick($event)">
          {{ 'Home.viewcourses' | translate }}
        </a>
      </div>
  </div>        
</div>
